import { render, staticRenderFns } from "./PowerOnSolshare.vue?vue&type=template&id=63217996&scoped=true"
import script from "./PowerOnSolshare.vue?vue&type=script&lang=js"
export * from "./PowerOnSolshare.vue?vue&type=script&lang=js"
import style0 from "./PowerOnSolshare.vue?vue&type=style&index=0&id=63217996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63217996",
  null
  
)

export default component.exports